import { useCallback, useEffect, useRef, useState } from "react";
import api from "@/lib/api";

export function Autocomplete({ value, onChange, placeholder, testid }) {
  const [sug, setSug] = useState([]);
  const [open, setOpen] = useState(false);
  const timer = useRef(null);

  const query = useCallback(async (q) => {
    if (!q || q.length < 3) { setSug([]); return; }
    try {
      const { data } = await api.get("/geo/autocomplete", { params: { q } });
      setSug(data.results || []); setOpen(true);
    } catch { setSug([]); }
  }, []);

  return (
    <div className="relative">
      <input className="input" placeholder={placeholder} value={value} data-testid={testid}
        onChange={e => {
          onChange(e.target.value);
          if (timer.current) clearTimeout(timer.current);
          timer.current = setTimeout(() => query(e.target.value), 300);
        }}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        onFocus={() => value && value.length >= 3 && setOpen(true)}/>
      {open && sug.length > 0 && (
        <ul className="absolute z-10 w-full mt-1 bg-neutral-900 border border-neutral-700 rounded max-h-56 overflow-y-auto">
          {sug.map((s, i) => (
            <li key={i} className="px-3 py-2 cursor-pointer hover:bg-neutral-800 text-sm"
              onMouseDown={() => { onChange(s.label); setOpen(false); }}>{s.label}</li>
          ))}
          <li className="px-3 py-1 text-xs opacity-50">Press Esc or type to use your own</li>
        </ul>
      )}
    </div>
  );
}

export function Typeahead({ kind, value, onChange, placeholder, testid }) {
  const [sug, setSug] = useState([]); const [open, setOpen] = useState(false);
  const timer = useRef(null);
  async function q(v) {
    if (!v || v.length < 2) { setSug([]); return; }
    try { const { data } = await api.get("/suggest", { params: { kind, q: v } }); setSug(data.suggestions||[]); setOpen(true); } catch {}
  }
  return (
    <div className="relative">
      <input className="input" placeholder={placeholder} value={value} data-testid={testid}
        onChange={e=>{onChange(e.target.value); if (timer.current) clearTimeout(timer.current); timer.current = setTimeout(()=>q(e.target.value),250);}}
        onBlur={()=>setTimeout(()=>setOpen(false),150)}/>
      {open && sug.length > 0 && (
        <ul className="absolute z-10 w-full mt-1 bg-neutral-900 border border-neutral-700 rounded max-h-56 overflow-y-auto">
          {sug.map((s,i)=>(<li key={i} className="px-3 py-2 cursor-pointer hover:bg-neutral-800 text-sm"
            onMouseDown={()=>{ onChange(s); setOpen(false); }}>{s}</li>))}
        </ul>
      )}
    </div>
  );
}
